"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { getIpfsUrl } from "../../../../shared/utils/ipfs.js";
import { client as defaultClient } from "../../../../shared/utils/thirdweb.js";
import { MediaRenderer } from "thirdweb/react";
/**
 * IPFSMediaRenderer - A wrapper around Thirdweb's MediaRenderer that configures
 * the IPFS gateway URL to use our validated gateway.
 *
 * Features:
 * - Configures MediaRenderer to use cloudflare-ipfs.com gateway
 * - Gateway matches our allowed list in profileDisplay.ts
 * - Provides fallback for missing sources
 *
 * @example
 * ```tsx
 * <IPFSMediaRenderer
 *   src="ipfs://QmX..."
 *   alt="Profile Avatar"
 *   className="size-14 rounded-full"
 * />
 * ```
 */
export function IPFSMediaRenderer({ src, alt = "Media", className, client = defaultClient, width, height, controls, style, onError, }) {
    // If no source, render fallback
    if (!src) {
        return (_jsx("div", { className: className, style: style, "aria-label": alt, children: _jsx("div", { className: "bg-b3-primary-wash flex h-full w-full items-center justify-center rounded-full", children: _jsx("span", { className: "text-b3-grey font-neue-montreal-semibold text-xs", children: alt.charAt(0).toUpperCase() }) }) }));
    }
    // Convert IPFS URLs to HTTP gateway URLs using our preferred gateway
    // This avoids Thirdweb's default cloudflare-ipfs.com which can be unreliable
    const resolvedSrc = src.startsWith("ipfs://") ? getIpfsUrl(src) : src;
    // Wrap in a span with onErrorCapture to catch img/video load errors from
    // MediaRenderer, which doesn't expose an onError prop itself.
    return (_jsx("span", { onErrorCapture: onError, className: "contents", children: _jsx(MediaRenderer, { src: resolvedSrc, client: client, alt: alt, className: className, width: width ? width.toString() : undefined, height: height ? height.toString() : undefined, controls: controls, style: style }) }));
}
